<template>

  <div class="vflex">
    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class=title>
          <h4>{{ $t('Talent Groups') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <input-keyword
              @input="setKeywords"
              :placeholder="$t('Search')"
              class="mr-2" />
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('Novo Talent Group') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">

          <table class="table table-hover">
            <tbody>
              <RhevolutJobListItem
                v-for="(bucket, i) in buckets"
                :key="`bucket-${i}`"
                :bucket="bucket" />
            </tbody>
          </table>

        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <RhevolutJobListForm
        v-if="modal_select"
        :initValue="modal_select" 
        @hideModal="hideModal()"
        @deleted="loadData(); hideModal()" 
        @saved="loadData(paginate.page); hideModal()" />

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import RhevolutJobListForm from './RhevolutJobListForm'
import RhevolutJobListItem from './RhevolutJobListItem'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'Bucket',
  components: {
    RhevolutJobListForm,
    RhevolutJobListItem,
    ThSort,
    InputKeyword,
    Paginaty
  },
  data () {
    return {
      creating: false,
      loading: false,
      modal_select: false,
      filters: {},
      sort: 'name',
      selected: [],
      modelType: 'candidate'
    }
  },
  computed: {
    buckets () {
      return [
        {
          title: 'Software Engineer',
          matchs_total: 45,
          new_total: 10,
          created_at: '2024-07-19',
          aborded_total: 5,
          applied_total: 30,
          analyzing_total: 15,
          status: 'publish',
          open_job: true
        },
        {
          title: 'Data Scientist',
          matchs_total: 38,
          new_total: 8,
          created_at: '2024-07-18',
          aborded_total: 4,
          applied_total: 25,
          analyzing_total: 10,
          status: 'archived',
          open_job: false
        },
        {
          title: 'Project Manager',
          matchs_total: 50,
          new_total: 12,
          created_at: '2024-07-17',
          aborded_total: 6,
          applied_total: 35,
          analyzing_total: 18,
          status: 'publish',
          open_job: true
        },
        {
          title: 'Product Owner',
          matchs_total: 42,
          new_total: 9,
          created_at: '2024-07-16',
          aborded_total: 7,
          applied_total: 28,
          analyzing_total: 14,
          status: 'archived',
          open_job: false
        },
        {
          title: 'UX Designer',
          matchs_total: 36,
          new_total: 11,
          created_at: '2024-07-15',
          aborded_total: 3,
          applied_total: 22,
          analyzing_total: 12,
          status: 'publish',
          open_job: true
        },
        {
          title: 'Marketing Specialist',
          matchs_total: 48,
          new_total: 13,
          created_at: '2024-07-14',
          aborded_total: 5,
          applied_total: 33,
          analyzing_total: 16,
          status: 'archived',
          open_job: false
        },
        {
          title: 'DevOps Engineer',
          matchs_total: 40,
          new_total: 10,
          created_at: '2024-07-13',
          aborded_total: 6,
          applied_total: 27,
          analyzing_total: 15,
          status: 'publish',
          open_job: true
        },
        {
          title: 'Business Analyst',
          matchs_total: 37,
          new_total: 7,
          created_at: '2024-07-12',
          aborded_total: 4,
          applied_total: 24,
          analyzing_total: 13,
          status: 'archived',
          open_job: false
        },
        {
          title: 'HR Manager',
          matchs_total: 44,
          new_total: 9,
          created_at: '2024-07-11',
          aborded_total: 7,
          applied_total: 31,
          analyzing_total: 17,
          status: 'publish',
          open_job: true
        },
        {
          title: 'Financial Analyst',
          matchs_total: 39,
          new_total: 8,
          created_at: '2024-07-10',
          aborded_total: 5,
          applied_total: 26,
          analyzing_total: 14,
          status: 'archived',
          open_job: false
        },
        {
          title: 'Account Manager',
          matchs_total: 41,
          new_total: 10,
          created_at: '2024-07-09',
          aborded_total: 6,
          applied_total: 29,
          analyzing_total: 15,
          status: 'publish',
          open_job: true
        },
        {
          title: 'Backend Developer',
          matchs_total: 49,
          new_total: 12,
          created_at: '2024-07-08',
          aborded_total: 8,
          applied_total: 32,
          analyzing_total: 18,
          status: 'archived',
          open_job: false
        },
        {
          title: 'Frontend Developer',
          matchs_total: 43,
          new_total: 11,
          created_at: '2024-07-07',
          aborded_total: 5,
          applied_total: 28,
          analyzing_total: 15,
          status: 'publish',
          open_job: true
        },
        {
          title: 'Sales Executive',
          matchs_total: 35,
          new_total: 9,
          created_at: '2024-07-06',
          aborded_total: 3,
          applied_total: 23,
          analyzing_total: 11,
          status: 'archived',
          open_job: false
        },
        {
          title: 'Customer Support',
          matchs_total: 38,
          new_total: 7,
          created_at: '2024-07-05',
          aborded_total: 4,
          applied_total: 25,
          analyzing_total: 12,
          status: 'publish',
          open_job: true
        },
        {
          title: 'QA Engineer',
          matchs_total: 46,
          new_total: 12,
          created_at: '2024-07-04',
          aborded_total: 6,
          applied_total: 30,
          analyzing_total: 16,
          status: 'archived',
          open_job: false
        },
        {
          title: 'Systems Administrator',
          matchs_total: 40,
          new_total: 10,
          created_at: '2024-07-03',
          aborded_total: 5,
          applied_total: 27,
          analyzing_total: 14,
          status: 'publish',
          open_job: true
        },
        {
          title: 'Mobile Developer',
          matchs_total: 47,
          new_total: 11,
          created_at: '2024-07-02',
          aborded_total: 7,
          applied_total: 33,
          analyzing_total: 17,
          status: 'archived',
          open_job: false
        },
        {
          title: 'Network Engineer',
          matchs_total: 36,
          new_total: 8,
          created_at: '2024-07-01',
          aborded_total: 4,
          applied_total: 22,
          analyzing_total: 13,
          status: 'publish',
          open_job: true
        },
        {
          title: 'IT Support',
          matchs_total: 37,
          new_total: 9,
          created_at: '2024-06-30',
          aborded_total: 3,
          applied_total: 23,
          analyzing_total: 12,
          status: 'archived',
          open_job: false
        }
      ]
    },
    paginate () {
      return {
        total: 60,
        pages: 2,
        page: 1
      }
    }
  },
  created () {
  },
  methods: {
    loadData () {

    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {
        type: this.modelType
      }
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    changeModelType (type) {
      this.creating = true
      this.modelType = type
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RhevolutJobList/RhevolutJobList.vue